import React from 'react';
import { Grid, Typography, makeStyles } from '@material-ui/core';
import TextInput from '../../../../Components/Inputs/TextInput';

const PassKeyQuestionChallenge = props => {
  const { id, description, label, register, loading, formHelpers } = props;

  const classes = useStyles();

  return (
    <>
      <div key={id} className={classes.questionContainer}>
        <Grid container direction="row">
          <Grid item xs={12} sm={6} className={classes.questionText}>
            <Typography>{description}</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextInput
              inputRef={register}
              name={formHelpers.getFieldPath(id, 'value')}
              autoFocus
              fullWidth
              disabled={loading}
              label={label}
              required={true}
              error={Boolean(formHelpers.getFieldError(id, 'value'))}
              helperText={formHelpers.getFieldErrorMessage(id, 'value')}
              InputProps={{
                inputProps: {
                  type: 'text',
                  inputMode: 'numeric'
                }
              }}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  sectionText: {
    margin: theme.spacing(2, 0, 3, 0)
  },
  questionContainer: {
    marginBottom: theme.spacing()
  },
  questionText: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(0.5)
  },
  month: {
    fontWeight: 500
  }
}));

export default PassKeyQuestionChallenge;
